<template>
    <article
        v-for="item in researchItemData"
        :key="item.id"
        :class="[{'_without-descr': !useDescription}, addClasses]"
        class="a-research-item"
    >
        <div class="a-research-item__wrapper">
            <div class="a-research-item__date">
                {{ item.props.period }}
            </div>
            <h3
                v-if="item.name"
                class="a-research-item__title"
                v-html="item.name">
            </h3>
            <p v-if="useDescription" v-html="item.preview_text" class="a-research-item__desc"></p>
        </div>
        <div class="a-research-item__links-wrap">
            <a
                v-if="item.props.file"
                class="a-research-item__link a-arrow-icon"
                :href="item.props.file.src"
                :title="item.props.title"
                target="_blank">
                Читать отчет
            </a>
            <a
                v-if="item.props.href_press_release"
                class="a-research-item__link a-arrow-icon"
                :href="item.props.href_press_release"
                :title="item.title"
                target="_blank">
                Пресс-релиз
            </a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'ResearchItem',
        props: {
            researchItemData: Object,
            addClasses: String,
            useDescription: {
              type: Boolean,
              default: true
            }
        }
    }
</script>